import { createHelpers } from 'vuex-map-fields';

const { mapFields: mapFieldsAuth } = createHelpers({
  getterType: 'getAuthField',
  mutationType: 'updateAuthField',
});

const { mapFields: mapFieldsCareService } = createHelpers({
  getterType: 'getCareServiceField',
  mutationType: 'updateCareServiceField',
});

const { mapFields: mapFieldsUser } = createHelpers({
  getterType: 'getUserField',
  mutationType: 'updateUserField',
});

const { mapFields: mapFieldsHealth } = createHelpers({
  getterType: 'getHealthField',
  mutationType: 'updateHealthField',
});

const { mapFields: mapFieldsCareLevelCalculator } = createHelpers({
  getterType: 'getCareLevelCalculatorField',
  mutationType: 'updateCareLevelCalculatorField',
});

const { mapFields: mapFieldsContentSheet } = createHelpers({
  getterType: 'getContentSheetField',
  mutationType: 'updateContentSheetField',
});

const { mapFields: mapFieldsTask } = createHelpers({
  getterType: 'getTasksField',
  mutationType: 'updateTasksField',
});

const { mapFields: mapFieldsApplication } = createHelpers({
  getterType: 'getApplicationField',
  mutationType: 'updateApplicationField',
});

export {
  mapFieldsAuth,
  mapFieldsCareService,
  mapFieldsUser,
  mapFieldsHealth,
  mapFieldsCareLevelCalculator,
  mapFieldsContentSheet,
  mapFieldsTask,
  mapFieldsApplication,
};
